import React, { useCallback, useMemo, useReducer } from 'react';

import navigationConstants    from './navigation.constants';
import NavigationContext      from './navigation.context';
import navigationReducer      from './navigation.reducer';
import navigationInitialState from './navigation.state';

/**
 * @type {React.FC}
 */
function NavigationProvider({
  children,
  value,
}) {
  const [state, dispatch] = useReducer(navigationReducer, {
    ...navigationInitialState,
    menu:               value ?? navigationInitialState.menu,
    initialStateLoaded: !!value.left && !!value.right,
  });

  const expandSection = useCallback((ids) => {
    dispatch({
      type: navigationConstants.NAV_EXPAND_SECTION,
      ids,
    });
  }, [dispatch]);

  const setBehavior = useCallback((behavior) => {
    dispatch({
      type: navigationConstants.NAV_SET_BEHAVIOR,
      behavior,
    });
  }, [dispatch]);

  const toggleState = useCallback((open) => {
    dispatch({
      type: navigationConstants.NAV_TOGGLE_STATE,
      open,
    });
  }, [dispatch]);

  const context = useMemo(() => ({
    ...state,
    expandSection,
    setBehavior,
    toggleState,
  }), [expandSection, setBehavior, toggleState, state]);

  return (
    <NavigationContext.Provider value={context}>
      {children}
    </NavigationContext.Provider>
  );
}

export default NavigationProvider;